// extracted by mini-css-extract-plugin
export default {"partTag":"styles_partTag__2xNco"};